import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMarkerCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMarkerCircle"><Path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM6.50305 17.8124C7.21573 16.9009 7.66425 16.0745 8.00002 15H16C16.3358 16.0744 16.7843 16.9009 17.4969 17.8124C16.0636 19.1684 14.1289 20 12 20C9.87107 20 7.93641 19.1684 6.50305 17.8124ZM9 13V10L15 8.5V13H9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMarkerCircle;
